/**
 * flor.ts — Categoría "Floristería" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_flor",
  skuPrefix: "FLO",
  categoria: "Floristería",
} as const;

export const cat_flor_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Ramo de Rosas Rojas x12",
    marca: "Floristería Elegante",
    origen: "Colombia",
    costo: 35000,
    precio: 54900,
    stock: 30,
    stockMinimo: 10,
    stockMaximo: 60,
    unidad: "ramo",
    ubicacionFisica: "Nevera FL1",
    proveedor: "Flores El Tropical",
    vencimientoMeses: 0,
    descripcionLarga:
      "Ramo clásico de 12 rosas rojas frescas 50cm de tallo. Envuelto en papel decorativo con cinta.",
    especificaciones: [
      { clave: "Cantidad", valor: "12 rosas" },
      { clave: "Tallo", valor: "50cm" },
    ],
    imageKeywords: ["red-roses", "rose-bouquet", "flowers"],
    color: "bg-red-600",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Arreglo Girasoles",
    marca: "Floristería Elegante",
    origen: "Colombia",
    costo: 55000,
    precio: 84900,
    stock: 15,
    stockMinimo: 4,
    stockMaximo: 30,
    unidad: "arreglo",
    ubicacionFisica: "Nevera FL1",
    proveedor: "Flores El Tropical",
    descripcionLarga:
      "Arreglo de 6 girasoles grandes acompañados de follaje y flores silvestres en florero vidrio.",
    especificaciones: [
      { clave: "Flores", valor: "6 girasoles" },
      { clave: "Florero", valor: "Incluido" },
    ],
    imageKeywords: ["sunflowers", "sunflower-bouquet", "flower-arrangement"],
    color: "bg-yellow-500",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Orquídea en Maceta",
    marca: "Green Life",
    origen: "Colombia",
    costo: 65000,
    precio: 99900,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "unidad",
    ubicacionFisica: "Estante FL2",
    proveedor: "Green Life Plantas",
    descripcionLarga:
      "Orquídea Phalaenopsis blanca en maceta decorativa cerámica 12cm. Floración 2-3 meses.",
    especificaciones: [
      { clave: "Variedad", valor: "Phalaenopsis" },
      { clave: "Floración", valor: "2-3 meses" },
    ],
    imageKeywords: ["orchid", "white-orchid", "potted-flower"],
    color: "bg-white",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Bouquet Mixto Premium",
    marca: "Floristería Elegante",
    origen: "Colombia",
    costo: 85000,
    precio: 129000,
    stock: 12,
    stockMinimo: 4,
    stockMaximo: 24,
    unidad: "ramo",
    ubicacionFisica: "Nevera FL1",
    proveedor: "Flores El Tropical",
    descripcionLarga:
      "Bouquet premium con rosas, lirios, gerberas y follaje de temporada. Ideal eventos especiales.",
    especificaciones: [
      { clave: "Tipos flores", valor: "4+" },
      { clave: "Presentación", valor: "Ramo premium" },
    ],
    imageKeywords: ["mixed-bouquet", "flower-arrangement", "premium-flowers"],
    color: "bg-pink-500",
    shape: "circle",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Planta Suculenta",
    marca: "Green Life",
    origen: "Colombia",
    costo: 18500,
    precio: 28900,
    stock: 45,
    stockMinimo: 10,
    stockMaximo: 90,
    unidad: "unidad",
    ubicacionFisica: "Estante FL2",
    proveedor: "Green Life Plantas",
    descripcionLarga:
      "Suculenta variada en maceta terracota 8cm. Planta de interior, riego mensual, requiere luz indirecta.",
    especificaciones: [
      { clave: "Maceta", valor: "Terracota 8cm" },
      { clave: "Cuidado", valor: "Bajo" },
    ],
    imageKeywords: ["succulent", "potted-plant", "indoor-plant"],
    color: "bg-green-500",
    shape: "circle",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Arreglo Condolencias",
    marca: "Floristería Elegante",
    origen: "Colombia",
    costo: 125000,
    precio: 189000,
    stock: 8,
    stockMinimo: 3,
    stockMaximo: 16,
    unidad: "arreglo",
    ubicacionFisica: "Nevera FL1",
    proveedor: "Flores El Tropical",
    descripcionLarga:
      "Arreglo fúnebre tipo corona con rosas blancas, lirios y follaje. Trípode incluido, tarjeta gratis.",
    especificaciones: [
      { clave: "Tipo", valor: "Corona" },
      { clave: "Incluye", valor: "Trípode + tarjeta" },
    ],
    imageKeywords: ["funeral-flowers", "sympathy-arrangement", "white-flowers"],
    color: "bg-white",
    shape: "circle",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Caja de Rosas Preservadas",
    marca: "Eternal Rose",
    origen: "Colombia",
    costo: 125000,
    precio: 189000,
    stock: 15,
    stockMinimo: 4,
    stockMaximo: 30,
    unidad: "caja",
    ubicacionFisica: "Vitrina FL3",
    proveedor: "Eternal Rose Co.",
    descripcionLarga:
      "9 rosas preservadas rojas en caja de lujo. Duran 1-3 años sin agua. Ideal regalo memorable.",
    especificaciones: [
      { clave: "Rosas", valor: "9 preservadas" },
      { clave: "Duración", valor: "1-3 años" },
    ],
    imageKeywords: ["preserved-roses", "eternal-roses", "rose-box"],
    color: "bg-red-700",
    shape: "square",
    gastoMargen: "ambicioso",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Flores Tipo Bouquet Novia",
    marca: "Floristería Elegante",
    origen: "Colombia",
    costo: 185000,
    precio: 289000,
    stock: 5,
    stockMinimo: 2,
    stockMaximo: 10,
    unidad: "ramo",
    ubicacionFisica: "Nevera FL1",
    proveedor: "Flores El Tropical",
    descripcionLarga:
      "Ramo nupcial cascada con rosas blancas, peonías y eucalipto. Diseño personalizable. Reserva 72h antes.",
    especificaciones: [
      { clave: "Estilo", valor: "Cascada" },
      { clave: "Personalizable", valor: "Sí" },
    ],
    imageKeywords: ["wedding-bouquet", "bridal-flowers", "white-bouquet"],
    color: "bg-white",
    shape: "circle",
    gastoMargen: "ambicioso",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Planta Cactus Mediano",
    marca: "Green Life",
    origen: "Colombia",
    costo: 28500,
    precio: 44900,
    stock: 35,
    stockMinimo: 8,
    stockMaximo: 70,
    unidad: "unidad",
    ubicacionFisica: "Estante FL2",
    proveedor: "Green Life Plantas",
    descripcionLarga:
      "Cactus columnar 25cm de alto en maceta ceramica. Resistente, ideal ambientes secos y soleados.",
    especificaciones: [
      { clave: "Altura", valor: "25cm" },
      { clave: "Cuidado", valor: "Muy bajo" },
    ],
    imageKeywords: ["cactus", "potted-cactus", "desert-plant"],
    color: "bg-green-600",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Canasta Frutal y Flores",
    marca: "Floristería Elegante",
    origen: "Colombia",
    costo: 95000,
    precio: 149000,
    stock: 10,
    stockMinimo: 3,
    stockMaximo: 20,
    unidad: "canasta",
    ubicacionFisica: "Estante FL3",
    proveedor: "Flores El Tropical",
    descripcionLarga:
      "Canasta gift con frutas de temporada, chocolates y ramo pequeño de flores. Ideal regalo corporativo.",
    especificaciones: [
      { clave: "Contenido", valor: "Fruta+choco+flores" },
      { clave: "Presentación", valor: "Canasta mimbre" },
    ],
    imageKeywords: ["gift-basket", "fruit-basket", "flower-basket"],
    color: "bg-amber-400",
    shape: "circle",
  }),
];
